import React from "react";
import { Container } from "react-bootstrap";
import "./LandingPage.css";
import "./AboutPage.css";

export default function TermsPage() {
  return (
    <div className="about-page">
      <main className="about-content">
        <Container>
          <div className="about-header">
            <h1 className="about-title">Terms of Service</h1>
            <p className="about-subtitle">
              Last updated: June 10, 2026 • Governing jurisdiction: Ontario,
              Canada
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">1. Acceptance of Terms</h2>
            <p className="about-text">
              By accessing or using the Podium hockey league management platform
              (the "Service"), you agree to be bound by these Terms of Service.
              If you do not agree, do not use the Service.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">2. Description of Service</h2>
            <p className="about-text">
              Podium is a platform for managing amateur hockey leagues,
              including tracking seasons, teams, players, games, goals,
              penalties, and statistics. The Service is provided on an "as is"
              and "as available" basis.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">3. User Accounts</h2>
            <p className="about-text">
              You are responsible for maintaining the confidentiality of your
              account credentials. You are responsible for all activity that
              occurs under your account. You agree to notify us immediately of
              any unauthorized use of your account.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">4. Acceptable Use</h2>
            <p className="about-text">
              You agree to use the Service only for its intended purpose of
              managing hockey league operations. You agree not to use the
              Service for any unlawful purpose or in any way that could harm the
              Service or other users.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">5. Disclaimer of Warranties</h2>
            <p className="about-text">
              The Service is provided "as is" without any warranties of any
              kind, express or implied. We do not warrant that the Service will
              be uninterrupted, error-free, or free from data loss. We make no
              warranty regarding the accuracy or completeness of any data stored
              or displayed through the Service.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">6. Limitation of Liability</h2>
            <p className="about-text">
              To the fullest extent permitted by applicable law in Ontario,
              Canada:
            </p>
            <ul style={{ marginLeft: "24px", lineHeight: "1.7" }}>
              <li className="about-text">
                We are not liable for any loss or corruption of data, however
                caused.
              </li>
              <li className="about-text">
                We are not liable for any interruption or unavailability of the
                Service.
              </li>
              <li className="about-text">
                We are not liable for any unauthorized access to your account or
                data.
              </li>
              <li className="about-text">
                We are not liable for any direct, indirect, incidental, special,
                exemplary, or consequential damages of any kind arising from
                your use of or inability to use the Service.
              </li>
            </ul>
            <p className="about-text">
              You use the Service entirely at your own risk.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">7. Indemnification</h2>
            <p className="about-text">
              You agree to indemnify and hold harmless Podium and its operators
              from any claims, damages, losses, or expenses (including legal
              fees) arising from your use of the Service or your violation of
              these Terms.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">8. Governing Law</h2>
            <p className="about-text">
              These Terms of Service are governed by and construed in accordance
              with the laws of the Province of Ontario and the federal laws of
              Canada applicable therein. Any disputes shall be subject to the
              exclusive jurisdiction of the courts of Ontario.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">9. Changes to Terms</h2>
            <p className="about-text">
              We reserve the right to modify these Terms at any time. Continued
              use of the Service after changes are posted constitutes your
              acceptance of the updated Terms.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">10. Entire Agreement</h2>
            <p className="about-text">
              These Terms, together with the Privacy Policy, constitute the
              entire agreement between you and Podium with respect to the
              Service.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">11. Contact</h2>
            <p className="about-text">
              If you have questions about these Terms, you may contact the
              league administrator for your league.
            </p>
          </div>
        </Container>
      </main>
    </div>
  );
}
